import { createSelector } from 'reselect';
import { draftTrackerNavSelector } from './nav-selector';

export const draftTrackerFilterSelector = createSelector(
    draftTrackerNavSelector,
    (nav) => nav.filter
);
